import styled from "styled-components";

export const LeftHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Container = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ConsultaPreviaMapContainer = styled.div`
    width: 500px;
    height: 550px;
    border: 2px solid black;
`;
